import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6 mb-4" }
const _hoisted_3 = { class: "btn-group" }
const _hoisted_4 = { class: "col-md-6" }

import AppPageHeader from "@/components/app/AppPageHeader.vue";
import TheTodoList from "@/components/TheTodoList.vue";
import { inject } from "vue";
import { notifyInjectionKey } from "@/keys";
import AppComponentHeader from "@/components/app/AppComponentHeader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ThePlayground',
  setup(__props) {

const notify = inject(notifyInjectionKey)

function onNotifyCLick (type: string) {
  notify?.({
    title: 'Some title',
    text: 'Some text',
    type,
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppPageHeader, null, {
      default: _withCtx(() => [
        _createTextVNode("Playground")
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(AppComponentHeader, null, {
          default: _withCtx(() => [
            _createTextVNode("Notify")
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onNotifyCLick('info')))
          }, "Info"),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-warning",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (onNotifyCLick('warn')))
          }, "Wanting"),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-danger",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (onNotifyCLick('error')))
          }, "Danger"),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-success",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (onNotifyCLick('success')))
          }, "Success")
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(TheTodoList)
      ])
    ])
  ], 64))
}
}

})